import {
  Directive,
  forwardRef,
  HostBinding,
  Renderer2,
  ElementRef,
  ChangeDetectorRef,
  Attribute,
  HostListener,
  OnInit
} from "@angular/core";

import { NG_VALUE_ACCESSOR } from "@angular/forms";
import { TextFormElement } from "../text/text-form-element";

@Directive({
    selector: "input[acCheckbox]",
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => CheckboxDirective),
            multi: true
        }
    ],
    standalone: false
})
export class CheckboxDirective extends TextFormElement {
  formClass = false;
  maring = true;

  @HostListener("change", ["$event"])
  onchange(event) {
    this.change(event.currentTarget.checked);
  }

  constructor(
    protected renderer: Renderer2,
    protected el: ElementRef,
    protected csRef: ChangeDetectorRef,
    @Attribute("updateEvent") protected updateEvent
  ) {
    super(renderer, el, csRef, updateEvent);
  }

  internalChecbox: boolean = false;

  get checkboxvalue(): any {
    return this.internalChecbox == true ? "Y" : "N";
  }
  set checkboxvalue(value: any) {
    this.internalChecbox = value == "Y" ? true : false;
  }
}
